import {Item, Menu} from './styles';

export const ContextMenu = {
  Item,
  Menu,
};
